module.exports = __webpack_public_path__ + "img/intl_icon.a4bb8666.svg";